module.exports = __webpack_public_path__ + "26ba00bb0e99e4075c35d523d9e76996.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SC.svg
// module id = WHuZ
// module chunks = 0